import { Carousel } from '@mantine/carousel'
import { Stack } from '@mantine/core'
import PropTypes from 'prop-types'
import TitleDivider from './divider'
import SeasonsCard from './seasons_card'
import NextSmallSVG from './buttons/next_carousel_button_small'
import PreviousSmallSVG from './buttons/previous_carousel_button_small'
import { useTranslations } from 'next-intl'

const truncateSynopsis = (text, maxLength) => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

function SeasonsCarousel({ seasons, title }) {
  // Filtrar y ordenar temporadas
  const filteredSeasons = seasons.filter((season) => season.episodes.length > 0)
  const t = useTranslations('SeasonsCard')

  const sortedSeasons = filteredSeasons.sort((a, b) => {
    if (a.number === 0) return 1
    if (b.number === 0) return -1
    return a.number - b.number
  })

  // Si no hay temporadas filtradas, no mostrar nada
  if (sortedSeasons.length === 0) {
    return null
  }

  return (
    <>
      <Stack spacing={0} mt={20}>
        <TitleDivider titleText={t('seasonsTitle') + title.toUpperCase()} />
      </Stack>
      <Carousel
        mt={7}
        w="100%"
        slideGap="sm"
        slideSize="20%"
        loop={false}
        align="start"
        slidesToScroll={1}
        sx={{ overflow: 'visible' }}
        nextControlIcon={<NextSmallSVG top={-140} width="100" height="280" />}
        previousControlIcon={
          <PreviousSmallSVG top={-140} width="100" height="280" />
        }
        styles={{
          control: {
            opacity: 1,
            cursor: 'pointer',
            backgroundColor: 'transparent',
            border: 'none',
            '&[data-inactive]': {
              opacity: 0,
              cursor: 'default'
            }
          }
        }}
      >
        {sortedSeasons.map((season) => (
          <Carousel.Slide key={season.number} sx={{ overflow: 'visible' }}>
            <SeasonsCard
              seasonNumber={season.title}
              premiereDate={new Date(season.release_date)}
              episodeQty={season.episodes.length}
              synopsis={truncateSynopsis(season.synopsis, 400)}
              imgSrc={season.image || '/placeholder.jpg'}
              title={title}
            />
          </Carousel.Slide>
        ))}
      </Carousel>
    </>
  )
}

SeasonsCarousel.propTypes = {
  seasons: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.number.isRequired,
      release_date: PropTypes.string.isRequired,
      episodes: PropTypes.arrayOf(
        PropTypes.shape({
          number: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
          synopsis: PropTypes.string
        })
      ).isRequired,
      image: PropTypes.string,
      synopsis: PropTypes.string
    })
  ).isRequired
}

export default SeasonsCarousel
